import Clipboard from '@react-native-clipboard/clipboard';

class ClipboardService {
	copyToClipboard({ text }: { text: string }) {
		Clipboard.setString(text);
	}
}

export default new ClipboardService();
